<ion-header>
  <ion-toolbar mode="ios" color="white">
    <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="ion-no-padding">
      <ion-text color="primary" class="ion-text-center">
        <h1>Spa QR Code</h1>
      </ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen="true">
  <ion-slides mode="ios" pager="ios" [options]="slideOpts" (ionSlideDidChange)="slideChanged()">
    <ion-slide>
      <ion-card color="primary">
        <ng-container *ngIf="loading">
          <div class="spinner-wrapper">
            <label>Qr Code Generating...</label>
            <ion-spinner name="crescent" color="white"></ion-spinner>
          </div>
        </ng-container>
        <ion-row class="rows" *ngIf="!loading">
          <ion-col class="cols" size="12" *ngIf="authServ.profile">
            <ion-text color="white" class="ion-text-center">
              <h3>{{authServ.profile.first_name}} {{authServ.profile.last_name}}</h3>
            </ion-text>
          </ion-col>
        </ion-row>
        <ion-row class="rows" *ngIf="!loading">
          <ion-col class="cols" size="12" *ngIf="authServ.profile">
            <div class="qr-code-frame">
              <qrcode [qrdata]="qrData" [width]="267" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
          </ion-col>
        </ion-row>
      </ion-card>
    </ion-slide>
    <ion-slide *ngIf="!loading">
      <ion-card class="membership-card">
        <ion-card-header>
          <ion-card-title>{{"Memberships" | translate}}</ion-card-title>
          <!-- <ion-card-subtitle>Card Subtitle</ion-card-subtitle> -->
        </ion-card-header>
        <ion-card-content>
          <ion-list>
            <ion-item [lines]="last ? 'none' : ''" *ngFor="let membership of memberships;let last = last;">
              <ion-thumbnail slot="start">
                <img src="../../../../assets/svg/membership.svg" />
              </ion-thumbnail>
              <ion-label>
                <h2>{{membership.name}}</h2>
                <p>{{membership.starts | date}} - {{membership.ends | date}}</p>
                <p class="{{membership.remainingDays == '0' ? 'red':'' }}"><b>{{membership.remainingDays}}</b>
                  {{"Days"| translate}}</p>
                <p class="{{membership.counter == '0' ? 'red':'' }}"><b>{{membership.counter}}</b> {{"Credit/Lesson" |
                  translate}}</p>
                <p *ngIf="(+membership.price )- (+membership.amount) > 0" class="red"><b>{{ (+membership.price) -
                    (+membership.amount) }}</b> {{"Unpaid Amount" | translate}}</p>
              </ion-label>
            </ion-item>
            <ion-label *ngIf="!memberships">
              <h3>{{"You currently have no active memberships." | translate}}</h3>
            </ion-label>
          </ion-list>
        </ion-card-content>
      </ion-card>
    </ion-slide>

  </ion-slides>

  <div class="slide-hint-arrow" *ngIf="showHintArrow">
    <img class="hand-icon" src="../../../../assets/svg/noun.png" alt="" srcset="">
    <!-- <ion-label>Abonelikler</ion-label> -->
  </div>

  <img class="shape" src="assets/img/logo-outline.svg">


</ion-content>